import {
  ProcessingActionTypes,
  ADD_ACTIVE_PROCESS,
  REMOVE_ACTIVE_PROCESS,
  UPDATE_PROCESS_STATUS
} from '../actions/processing.actions'
import { ProcessingStoreModel } from '../store.model'

const initialState: ProcessingStoreModel = {
  activeProcesses: {}
}

export const processingReducer = (
  state = initialState,
  action: ProcessingActionTypes
): ProcessingStoreModel => {
  switch (action.type) {
    case ADD_ACTIVE_PROCESS: {
      const newProcess = action.payload
      // Una ejecución solo puede tener un proceso flotante: el nuevo reemplaza al anterior
      const remainingProcesses = Object.values(state.activeProcesses).filter(
        process =>
          !(
            newProcess.processType === 'invoiceCycle' &&
            process.processType === 'invoiceCycle' &&
            process.executionCycleId === newProcess.executionCycleId
          )
      )
      return {
        ...state,
        activeProcesses: {
          ...remainingProcesses.reduce(
            (acc, process) => ({ ...acc, [process.processId]: process }),
            {}
          ),
          [newProcess.processId]: newProcess
        }
      }
    }

    case REMOVE_ACTIVE_PROCESS:
      const { [action.payload.processId]: removed, ...remainingProcesses } = state.activeProcesses
      return {
        ...state,
        activeProcesses: remainingProcesses
      }

    case UPDATE_PROCESS_STATUS:
      if (!state.activeProcesses[action.payload.processId]) {
        return state
      }
      return {
        ...state,
        activeProcesses: {
          ...state.activeProcesses,
          [action.payload.processId]: {
            ...state.activeProcesses[action.payload.processId],
            currentStatus: action.payload.newStatus
          }
        }
      }

    default:
      return state
  }
}
